module.exports = __webpack_public_path__ + "img/kangmingjian_img3.02b4581c.jpg";